/* eslint-disable no-undef */

import React from 'react';
import { TouchableOpacity, FlatList, View, Text, Image, ScrollView } from 'react-native';
import styles from '../InternalComponents/styles/style';
import { getResponsiveStyle, widthInPercentage } from '../../utils/appUtils';
import Hoverable from '../../components/hover/hoverable';
const formatData = (data, numColumns) => {
  const numberOfFullRows = Math.floor(data.length / numColumns);

  let numberOfElementsLastRow = data.length - numberOfFullRows * numColumns;
  while (
    numberOfElementsLastRow !== numColumns &&
    numberOfElementsLastRow !== 0
  ) {
    data.push({ key: `blank-${numberOfElementsLastRow}`, empty: true });
    numberOfElementsLastRow++;
  }

  return data;
};
var isFirefox = typeof InstallTrigger !== 'undefined';
export default class Leftsidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valueSelected: '',
      ServiceRequests: ''
    };
  }

  componentWillReceiveProps(newprops) {
    this.setState({ ServiceRequests: newprops.ServiceRequests })
  }
  omponentDidMount() {
    this.setState({ ServiceRequests: this.props.ServiceRequests, })
  }
  OnServiceRequestsButtonPress(servicename, menuType, index, menuHeader, menuname) {
    this.props.OnServiceRequestsButtonPress(servicename, menuType, index, menuHeader, menuname);
  }


  renderItemFunc = (item, index) => {
    const { measure } = this.props;
    if (item.empty === true) {
      return (
        <View
          style={[
            styles.serviceBoxPadding,
            { flex: 1, backgroundColor: 'transparent', justifyContent: this.state.machine != false ? 'space-around' : null },
            styles[getResponsiveStyle('serviceBoxPadding', measure)]
          ]}
        >
          <TouchableOpacity
            onPress={() => {
              this.OnServiceRequestsButtonPress(
                item.servicename,
                item.menuType,
                index,
                item.menuHeader,
                item.menuname
              );
            }}
          >
            <Text
              style={[
                styles.serviceText,
                styles[getResponsiveStyle('serviceText', measure)]
              ]}
            >
              {item.Title}
            </Text>
          </TouchableOpacity>
        </View>
      );
    }
    return (
      <View
        style={[
          styles.serviceBoxPadding,
          { flex: 1 },
          styles[getResponsiveStyle('serviceBoxPadding', measure)]
        ]}
      >
        <TouchableOpacity
          onPress={() => {
            this.OnServiceRequestsButtonPress(
              item.servicename,
              item.menuType,
              index,
              item.menuHeader,
              item.menuname
            );
          }}
          style={
            measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI'
              ? [
                {
                  height: 100,
                  borderRadius: 2,
                  elevation: Platform.OS === 'web' ? 5 : 2,
                  padding: '1%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  shadowColor: 'grey',
                  shadowOffset: {
                    width: 0,
                    height: 2
                  },
                  shadowOpacity: 0.2,
                  shadowRadius: 15,
                  backgroundColor: '#ffb571',
                }
              ]
              : [
                styles.serviceBox, { backgroundColor: item.serviceSelected ? '#ef6912' : 'white', },
                styles[getResponsiveStyle('serviceBox', measure)]
              ]
          }
        >
          <View
            style={
              measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI'
                ? null
                : [
                  styles.serviceImageView,
                  styles[getResponsiveStyle('serviceImageView', measure)]
                ]
            }
          >
            {`${item.images}`.includes('http') ? (
              <Image
                style={[
                  styles.serviceImageStyle,
                  styles[getResponsiveStyle('serviceImageStyle', measure)]
                ]}
                source={item.image_icons }
              />
            ) : (
              <Image
                style={[
                  styles.serviceImageStyle,
                  styles[getResponsiveStyle('serviceImageStyle', measure)]
                ]}
                source={{uri: item.image_icons }}
              />
            )}
          </View>
          <Hoverable>
            {(isHovered) => (
              <View
                style={[
                  styles.serviceTextView, { marginTop: widthInPercentage(10) },
                  styles[getResponsiveStyle('serviceTextView', measure)]
                ]}
              >
                {isHovered ? (
                  <Text
                    style={[
                      styles.serviceLeftText,
                      { color: item.serviceSelected ? 'white' : '#222222' },
                      styles[getResponsiveStyle('serviceLeftText', measure)]
                    ]}
                  >
                    {item.servicename}
                  </Text>)
                  : <Text
                    style={[
                      styles.serviceLeftText,
                      { color: item.serviceSelected ? 'white' : '#222222' },
                      styles[getResponsiveStyle('serviceLeftText', measure)]
                    ]}
                  >
                    {item.servicename}
                  </Text>}
                {/* <Text  style={[
                      styles.serviceDescText,
                      { color:item.serviceSelected ? 'white': '#222222',marginTop:widthInPercentage(3)},
                      styles[getResponsiveStyle('serviceDescText', measure)]
                    ]}>{item.text}</Text> */}
              </View>

            )}
          </Hoverable>
          <View style={{ alignItems: 'flex-end', marginTop: widthInPercentage(2) }}>
            <View style={{ backgroundColor: item.color, borderBottomEndRadius: 3, borderTopLeftRadius: 3, width: widthInPercentage(12) }}>

              <Image
                style={[
                  styles.serviceImageArrowStyle, { padding: 0 },
                  styles[getResponsiveStyle('serviceImageArrowStyle', measure)]
                ]}
                source={require('../../assets/images/menunewArrow.png')}
              />
            </View>

          </View>
        </TouchableOpacity>
      </View>

    );
  };


  render() {
    let props = this.props;
    const { measure, machine,headerFlag } = props;
    return (
      <View
        style={[
          styles.LeftsidebarMainView,
          { height: machine ? '100%' : '100%', },
          styles[getResponsiveStyle('LeftsidebarMainView', measure)]
        ]}
      >
        { machine ?
          <ScrollView>
            <View
              style={[
                styles.LeftsidebarInnerView,
                { height: props.machine ? '100%' : '100%', },
                styles[getResponsiveStyle('LeftsidebarInnerView', measure)]
              ]}

            >
              <FlatList
                data={formatData(this.state.ServiceRequests, 1, props)}
                renderItem={({ item, index }) => this.renderItemFunc(item, index)}
                numColumns={1}
                extraData={this.state}
              />

            </View>
          </ScrollView>
          : null

        }
        { machine ? null
          : <View style={{ height: props.machine ? '36.3%' : '100%', }}>
            <View
              style={[
                styles.LeftsidebarInnerView,
                { height: props.machine ? '36.3%' : isFirefox ? widthInPercentage(104) : '100%', },
                styles[getResponsiveStyle('LeftsidebarInnerView', measure)]
              ]}
            >
              {headerFlag ? null :
                <TouchableOpacity>
                  <View style={styles.seconLayerLogo}>
                    <Image
                      style={[
                        styles.TopNavImage1StyleView,
                        { height: 57 },
                        styles[getResponsiveStyle('TopNavImage1StyleView', measure)],
                        styles.iciciLogoWidthParams,
                        styles[getResponsiveStyle('iciciLogoWidthParams', measure)],
                      ]}
                      source={require('../../assets/images/icici-bank-logo.svg')}
                    />
                    <Image
                      style={[
                        styles.TopNavImage1StyleView,
                        { height: 57 },
                        styles[getResponsiveStyle('TopNavImage1StyleView', measure)],
                        styles.instaServeLogoWidthParams,
                        styles[getResponsiveStyle('instaServeLogoWidthParams', measure)],
                      ]}
                      source={require('../../assets/images/insta-serve-logo.png')}
                    />
                  </View>
                </TouchableOpacity>
              }

              <FlatList
                data={formatData(this.state.ServiceRequests, 2, props)}
                renderItem={({ item, index }) => this.renderItemFunc(item, index)}
                numColumns={2}
                extraData={this.state}
              />

            </View></View>

        }
      </View>
    );
  }
}
